<div class="overview-item">
  <span class="title">{{ 'STATISTICS.AVERAGE_CONTRACT_AGE_HEADER' | translate }}</span>
  <div class="d-flex align-items-center">
    <div class="flex-space-between">
      <div class="mr-3 text-align-center">
        <div class="unit">{{ 'STATISTICS.YEAR_SHORT_TEXT' | translate }}</div>
        <div class="amount-value">{{ years }}</div>
      </div>
      <div class="mr-3 text-align-center">
        <div class="unit">{{ 'STATISTICS.MONTH_SHORT_TEXT' | translate }}</div>
        <div class="amount-value">{{ months }}</div>
      </div>
      <div class="mr-3 text-align-center">
        <div class="unit">{{ 'STATISTICS.DAY_SHORT_TEXT' | translate }}</div>
        <div class="amount-value">{{ days }}</div>
      </div>
    </div>
  </div>
</div>
